import Name from './Name.jsx';

const FormField = {
    CardNumber: 'PaymentAccount',
    Code: 'code',
    Email: 'Email',
    ExpirationDate: 'Expiration',
    FirstName: 'FirstName',
    LastName: 'LastName',
    Message: 'Message',
    Name: 'Name',
    Notes: 'Notes',
    Password: 'Password',
    Phone: 'Phone',
    PriceFixed: 'PriceFixed',
    PricePercent: 'PricePercent',
    Search: 'q',
    SecurityCode: 'CVC',
    Subject: 'Subject',
    
    BillingAddress: {
        AddressLine1: 'BillingAddressLineOne',
        AddressLine2: 'BillingAddressLineTwo',
        City: 'BillingCity',
        Country: 'BillingCountry',
        State: 'BillingState',
        Zip: 'BillingZip'
    },
    ShippingAddress: {
        AddressLine1: 'AddressLineOne',
        AddressLine2: 'AddressLineTwo',
        City: 'City',
        Country: 'Country',
        State: 'State',
        Zip: 'Zip'
    },

    RequiredType: {
        AtLeastOne: 'atLeastOne',
        Deprecated: 'deprecated'
    },

    [Name.Block.Artist.Signup.Container]: {
        ErrorMessage: Name.Block.Artist.Signup.ErrorMessage,
        SubmitButtonV1: Name.Block.Artist.Signup.SubmitButtonV1,
        SubmitButtonV2: Name.Block.Artist.Signup.SubmitButtonV2,
        SuccessMessage: Name.Block.Artist.Signup.SuccessMessage
    },

    [Name.Block.Cart.CardForm.Container]: {
        ErrorMessage: Name.Block.Cart.CardForm.ErrorMessage,
        SameAddressCheckbox: Name.Block.Cart.CardForm.SameAddressCheckbox
    },

    [Name.Block.Contact.Form.Container]: {
        ErrorMessage: Name.Block.Contact.Form.ErrorMessage,
        SubmitButtonV1: Name.Block.Contact.Form.SubmitButtonV1,
        SubmitButtonV2: Name.Block.Contact.Form.SubmitButtonV2,
        SuccessMessage: Name.Block.Contact.Form.SuccessMessage
    },

    [Name.Block.Cart.PromoCode.Container]: {
        ErrorMessage: Name.Block.Cart.PromoCode.ErrorMessage,
        SubmitButtonV1: Name.Block.Cart.PromoCode.SubmitButtonV1,
        SubmitButtonV2: Name.Block.Cart.PromoCode.SubmitButtonV2
    },

    [Name.Block.Footer.SubscribeForm.Container]: {
        ErrorMessage: Name.Block.Footer.SubscribeForm.ErrorMessage,
        SubmitButtonV1: Name.Block.Footer.SubscribeForm.SubmitButtonV1,
        SubmitButtonV2: Name.Block.Footer.SubscribeForm.SubmitButtonV2,
        SuccessMessage: Name.Block.Footer.SubscribeForm.SuccessMessage
    },

    [Name.Block.Header.SearchBar.Container]: {
        SubmitButtonV1: Name.Block.Header.SearchBar.SubmitButtonV1,
        SubmitButtonV2: Name.Block.Header.SearchBar.SubmitButtonV2
    },

    [Name.Block.InquireForm.Container]: {
        ErrorMessage: Name.Block.InquireForm.ErrorMessage,
        SubmitButtonV1: Name.Block.InquireForm.SubmitButtonV1,
        SubmitButtonV2: Name.Block.InquireForm.SubmitButtonV2,
        SuccessMessage: Name.Block.InquireForm.SuccessMessage
    },

    [Name.Block.OfferForm.Container]: {
        ErrorMessage: Name.Block.OfferForm.ErrorMessage,
        SubmitButtonV1: Name.Block.OfferForm.SubmitButtonV1,
        SubmitButtonV2: Name.Block.OfferForm.SubmitButtonV2,
        SuccessMessage: Name.Block.OfferForm.SuccessMessage
    },

    [Name.Block.PasswordForm.Container]: {
        ErrorMessage: Name.Block.PasswordForm.ErrorMessage,
        SubmitButton: Name.Block.PasswordForm.SubmitButton
    },

    [Name.Block.SubscribeForm.Container]: {
        ErrorMessage: Name.Block.SubscribeForm.ErrorMessage,
        SubmitButtonV1: Name.Block.SubscribeForm.SubmitButtonV1,
        SubmitButtonV2: Name.Block.SubscribeForm.SubmitButtonV2,
        SuccessMessage: Name.Block.SubscribeForm.SuccessMessage
    }
};

export default FormField;